export default "__VITE_ASSET__CHKAS_be__"